/* eslint-disable no-undef */
import './Hompage.scss';
import './HomepageMobile.scss';

import { Search } from '@mui/icons-material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useNavigate } from 'react-router-dom';

import { buttonStyles, buttonStylesBlue, buttonStylesGreen } from '../../Components/docsAdministrative/JsObjectStyles';
import Footer from '../../Components/shared/Footer/Footer';
import NavbarHome from '../../Components/shared/Navbar/NavbarHome';
import { DrawFirstSvgHome, DrawIcon1Grid2Container6, DrawIcon2Container6, DrawIcon2Grid2Container6, DrawIcon3Container6, DrawIcon3Grid2Container6, DrawIcon4Container6, DrawIcon4Grid2Container6, DrawIcon5Grid2Container6, DrawIcon6Grid2Container6, DrawIconContainer6, DrawImgContainer5Home, DrawImgProcess, IconBox1container, IconBox2container, IconBox3container, IconBox4container, IconBox5container, IconBox6container, IconBox7container, IconBox8container, IconBox9container, IconContainer1Home } from '../../data/SVGs';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useWindowSize from '../../hooks/useWindowSize';
import blog1 from './../../Assets/blogs/blog1.jpg';
import blog4 from './../../Assets/blogs/blog4.jpg';
import blog5 from './../../Assets/blogs/blog5.jpg';
import blog8 from './../../Assets/blogs/blog8.jpg';
import imgPlatform from './../../Assets/homePage/Pltform.png';
import profile1img from './../../Assets/homePage/Profile.png';
import profile2img from './../../Assets/homePage/Profile2.png';
import profile3img from './../../Assets/homePage/Profile3.png';
import profile4img from './../../Assets/homePage/Profile4.png';
// ! why React becomes Too slow ..? SVG takes too much
// Could not find a declaration file for module 'react-trello'. 'C:/Users/Reda El Ouahabi/Desktop/HTH/hth_frontend/node_modules/react-trello/dist/index.js' implicitly has an 'any' type.
//   Try `npm i --save-dev @types/react-trello` if it exists or add a new declaration (.d.ts) file containing `declare module 'react-trello';

function HomePage() {

    // ! multiLanguages
    const { t, i18n } = useTranslation();

    // useEffect(() => {
    console.log(t, i18n);
    const navigate = useNavigate();
    usePersistedLanguage();
    //   return () => {
    //     second
    //   }
    // }, [])

    //! const index = 11;

    // alert("START")

    // const data = {
    //     lanes: [
    //         {
    //             id: 'lane1',
    //             title: 'Planned Tasks',
    //             label: '2/2',
    //             cards: [
    //                 { id: 'Card1', title: 'Write Blog', description: 'Can AI make memes', label: '30 mins', draggable: false },
    //                 { id: 'Card2', title: 'Pay Rent', description: 'Transfer via NEFT', label: '5 mins', metadata: { sha: 'be312a1' } }
    //             ]
    //         },
    //         {
    //             id: 'lane2',
    //             title: 'Completed',
    //             label: '0/0',
    //             cards: []
    //         }
    //     ]
    // }
    const { device } = useWindowSize();

    console.log('deviiice', device);
    return (
        <React.Fragment>
            <div
                className='App-intro'
                style={{background:'linear-gradient(171deg, rgba(255,255,255,1) 0%, rgba(229,243,235,1) 37%, rgba(232,238,253,1) 70%, rgba(255,255,255,1) 100%)'}}
            >
                <NavbarHome />

                <div className='rectangleP'>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '115px', alignItems: 'center', alignSelf: 'stretch' }}>
                        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '35px', alignSelf: 'stretch' }}>
                            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '55px', alignSelf: 'stretch' }}>
                                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '35px', alignSelf: 'stretch' }}>
                                    <div
                                        className='frame105HomePage'
                                        style={{ paddingTop: '40px' }}
                                    >
                                        <div className='frame106HomePage'>
                                            <div className='frame107HomePage'>
                                                <div className='frame108HomePage'>
                                                    <h3 className='frame101HomePage'>
                                                        {i18n.t('Nous sommes là pour vous aider et vous accompagner')}
                                                    </h3>
                                                    {device != 'desktop' &&
                                                        <div className='frame112HomePage'>
                                                            <DrawFirstSvgHome />
                                                        </div>
                                                    }
                                                    <h6 className='frame110HomePage'>
                                                        {i18n.t('Nous connectons les grandes entreprises aux Experts freelances et nous assurons leur accompagnement tout au long des projets grâce à notre solution \'end To end\'.')}
                                                    </h6>
                                                </div>
                                                <div className='frame111HomePage'>
                                                    <div className="frame0HomePage">
                                                        <Button
                                                            variant="contained"
                                                            style={{ ...buttonStylesGreen(false), ...{ height: '48px', width: device == 'desktop' ? 'fit-content' : '100%' } }}
                                                            onClick={() => {
                                                                navigate('/login');
                                                            }}
                                                            startIcon={<IconContainer1Home />}
                                                        > {i18n.t('Poster un besoin')}
                                                        </Button></div>
                                                    {device == 'desktop' &&
                                                        <p
                                                            className='frame1HomePage'
                                                            style={{ margin: '0px' }}
                                                        >{i18n.t('Ou')}</p>
                                                    }
                                                    <div className='frame0HomePage'>
                                                        <Button
                                                            variant="outlined"
                                                            style={{
                                                                ...buttonStyles(),
                                                                ...{
                                                                    borderColor: '#214DCE', color: '#214DCE', width: device == 'desktop' ? 'fit-content' : '100%'
                                                                }
                                                            }}
                                                            onClick={() => {
                                                                navigate('/login');
                                                            }}
                                                            startIcon={<Search />}
                                                        > {i18n.t('Trouver une mission')}</Button></div>
                                                </div>
                                            </div>
                                            {device == 'desktop' &&
                                                <div className='frame112HomePage'>
                                                    <DrawFirstSvgHome />
                                                </div>
                                            }
                                        </div>
                                        {/*<div className='frame113HomePage'>
                                            <h6 className='frame114HomePage'>Trusted by </h6>
                                            <div className='frame115HomePage'>
                                                <IconeTrustedBy1 />
                                                <IconeTrustedBy2 />
                                                <IconeTrustedBy3 />
                                                {device=='desktop' &&
                                                    <IconeTrustedBy4 />
                                                }
                                                <IconeTrustedBy5 />
                                            </div>
                                        </div>*/}
                                    </div>
                                    <div
                                        className='frame98HomePage'
                                        style={{ marginTop: device == 'desktop' ? '70px' : '0px' }}
                                    >
                                        <div className='frame99HomePage'>
                                            <div className='frame100HomePage'>
                                                <h3 className='frame101HomePage'>{i18n.t('Une plateforme unique et intuitive')} </h3>
                                                {device != 'desktop' &&
                                                    <div className='frame104HomePage'>
                                                        <img src={imgPlatform} />
                                                    </div>
                                                }
                                                <h6 className='frame110HomePage'>{i18n.t('High Tech Hires se distingue en tant que plateforme exclusive qui propose une solution intelligente, facile d\'utilisation et intuitive pour satisfaire les besoins de tous les utilisateurs : clients finaux, entreprises de services du numérique (ESN) et freelances.')}</h6>
                                            </div>
                                            <div className='frame103HomePage'>
                                                <Button
                                                    variant="contained"
                                                    sx={{ height: 56 }}
                                                    onClick={() => {
                                                        navigate('/demo');
                                                    }}
                                                    style={{ ...buttonStylesBlue(), ...{ width: device == 'desktop' ? 'fit-content' : '100%' } }}
                                                    startIcon={<CalendarTodayIcon />}
                                                > {i18n.t('Demander une Démo')}
                                                </Button>
                                            </div>
                                        </div>
                                        {device == 'desktop' &&
                                            <div className='frame104HomePage'>
                                                <img src={imgPlatform} />
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className='frame5HomePage'>
                                    <div className='frame6HomePage'>
                                        <h3 className='frame101HomePage'>
                                            <Trans>
                                                {i18n.t('Nos Métiers')}
                                            </Trans>
                                        </h3>
                                    </div>
                                    <div className='frame8HomePage'>
                                        <div className='frame9HomePage'>
                                            <div className='frame10HomePage'>
                                                <div className='frame11HomePage'>
                                                    <div className='frame12HomePage'>
                                                        <IconBox1container />
                                                    </div>
                                                    <p className='frame13HomePage'>
                                                        {i18n.t('Digital')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p className='frame14HomePage'>
                                                        {i18n.t('Des développeurs, chefs de projets, scrums masters, et bien d\'autres, qui possèdent une expertise variée dans de multiples technologies et langages.')}
                                                    </p>
                                                }
                                            </div>
                                            <div className='frame10HomePage'>
                                                <div className='frame11HomePage'>
                                                    <div className='frame12HomePage'>
                                                        <IconBox2container />
                                                    </div>
                                                    <p className='frame13HomePage'>
                                                        {i18n.t('Big Data')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p className='frame14HomePage'>
                                                        {i18n.t('Des Experts Data Engineer, Data Analyst et bien d\'autres professionnels, tous dotés d\'une expertise approfondie dans l\'analyse et le traitement des données.')}
                                                    </p>
                                                }
                                            </div>
                                            <div className='frame10HomePage'>
                                                <div className='frame11HomePage'>
                                                    <div className='frame12HomePage'>
                                                        <IconBox3container />
                                                    </div>
                                                    <p className='frame13HomePage'>
                                                        {i18n.t('DBA')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p className='frame14HomePage'>
                                                        {i18n.t('Des DBAs hautement qualifiés qui possèdent une expertise solide dans la conception, la gestion, l\'optimisation et la sécurisation des bases de données.')}
                                                    </p>
                                                }
                                            </div>
                                            <div className='frame10HomePage'>
                                                <div className='frame11HomePage'>
                                                    <div className='frame12HomePage'>
                                                        <IconBox4container />
                                                    </div>
                                                    <p className='frame13HomePage'>
                                                        {i18n.t('SAP')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p className='frame14HomePage'>
                                                        {i18n.t('Des expérimentés dans divers domaines, tels que MM, SD, FI, CO, PM, BW, etc., qui sont spécialisés dans toutes les solutions fournies par SAP.')}                                                </p>
                                                }
                                            </div>
                                            <div className='frame10HomePage'>
                                                <div className='frame11HomePage'>
                                                    <div className='frame12HomePage'>
                                                        <IconBox5container />
                                                    </div>
                                                    <p className='frame13HomePage'>
                                                        {i18n.t('Cloud')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p className='frame14HomePage'>
                                                        {i18n.t('Des spécialistes dans les domaines des infrastructures, de l\'hébergement, du stockage, de la sauvegarde de données, et bien d\'autres encore.')}
                                                    </p>
                                                }
                                            </div>
                                            <div className='frame10HomePage'>
                                                <div className='frame11HomePage'>
                                                    <div className='frame12HomePage'>
                                                        <IconBox6container />
                                                    </div>
                                                    <p className='frame13HomePage'>
                                                        {i18n.t('ERP/CRM/SCM')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p className='frame14HomePage'>
                                                        {i18n.t('Des consultants qualifiés qui possèdent une expertise dans Salesforces, Microsoft Dynamics, JDEdwards, Oracle, ainsi que dans d\'autres solutions et systèmes.')}</p>
                                                }
                                            </div>
                                            <div className='frame10HomePage'>
                                                <div className='frame11HomePage'>
                                                    <div className='frame12HomePage'>
                                                        <IconBox7container />
                                                    </div>
                                                    <p className='frame13HomePage'>
                                                        {i18n.t('Sécurité des SI')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p className='frame14HomePage'>
                                                        {i18n.t('Des spécialistes en cybersécurité, des administrateurs système et bien d\'autres professionnels possédant une expertise dans la sécurité des systèmes.')}
                                                    </p>
                                                }
                                            </div>
                                            <div className='frame10HomePage'>
                                                <div className='frame11HomePage'>
                                                    <div className='frame12HomePage'>
                                                        <IconBox8container />
                                                    </div>
                                                    <p className='frame13HomePage'>
                                                        {i18n.t('Devops')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p className='frame14HomePage'>
                                                        {i18n.t('Des Experts DevOps possédant une expertise avérée dans l\'application des meilleures pratiques tout au long du cycle de vie d\'un projet.')}
                                                    </p>
                                                }
                                            </div>
                                            <div className='frame10HomePage'>
                                                <div className='frame11HomePage'>
                                                    <div className='frame12HomePage'>
                                                        <IconBox9container />
                                                    </div>
                                                    <p className='frame13HomePage'>
                                                        {i18n.t('IA')}
                                                    </p>
                                                </div>
                                                {device == 'desktop' &&
                                                    <p className='frame14HomePage'>
                                                        {i18n.t('Des développeurs IA, data miners, et bien d\'autres experts, ayant une expertise dans le développement, les tests et le déploiement des modèles d\'IA.')}
                                                    </p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="frame19HomePage">
                                        <Button
                                            variant="contained"
                                            sx={{ height: 56 }}
                                            //style={{
                                            //    backgroundColor: '#214DCE',
                                            //    borderRadius: '8px',
                                            //}}
                                            onClick={() => {
                                                navigate('/login');
                                            }}
                                            style={{
                                                ...buttonStylesBlue(),
                                            }}
                                        > {i18n.t('Trouver un Expert')}</Button>
                                    </div>
                                </div>
                                <div className='frame20HomePage'>
                                    <div className='frame21HomePage'>
                                        <div className='frame22HomePage'>
                                            <div className='frame23HomePage'>
                                                <div className='frame24HomePage'>
                                                    <svg
                                                        width="24"
                                                        height="19"
                                                        viewBox="0 0 24 19"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M3 9.35156C1.98047 9.35156 0.75 10.125 0.75 11.6016C0.75 12.8672 1.73438 13.8516 3 13.8516C4.23047 13.8516 5.25 12.8672 5.25 11.6016C5.25 10.1602 3.98438 9.35156 3 9.35156ZM3 12.7266C2.36719 12.7266 1.875 12.2344 1.875 11.6016C1.875 11.0039 2.36719 10.4766 3 10.4766C3.59766 10.4766 4.125 11.0039 4.125 11.6016C4.125 12.2344 3.59766 12.7266 3 12.7266ZM7.21875 11.0391H6.62109C6.33984 11.0391 6.09375 11.3203 6.09375 11.6016C6.09375 11.8477 6.33984 12.1641 6.62109 12.1641H7.18359C7.5 12.1641 7.78125 11.918 7.78125 11.6016C7.78125 11.3203 7.5 11.0391 7.21875 11.0391ZM21 7.66406C21.9844 7.66406 23.25 6.92578 23.25 5.41406C23.25 3.9375 21.9844 3.16406 21 3.16406C19.9805 3.16406 18.75 3.9375 18.75 5.41406C18.75 6.67969 19.7344 7.66406 21 7.66406ZM21 4.28906C21.5977 4.28906 22.125 4.81641 22.125 5.41406C22.125 6.04688 21.5977 6.53906 21 6.53906C20.3672 6.53906 19.875 6.04688 19.875 5.41406C19.875 4.81641 20.3672 4.28906 21 4.28906ZM21 14.4141C20.5078 14.4141 20.0859 14.5547 19.7344 14.8008C19.5938 14.9062 19.4883 14.9766 19.418 15.082L16.1836 13.1484C16.3594 12.6562 16.5 12.1641 16.5 11.6016C16.5 9.45703 14.707 7.66406 12.5625 7.66406C12.1406 7.66406 11.7891 7.76953 11.4023 7.875L10.0312 4.92188C10.5234 4.5 10.875 3.86719 10.875 3.16406C10.875 1.72266 9.60938 0.914062 8.625 0.914062C7.14844 0.914062 6.375 2.17969 6.375 3.16406C6.375 4.42969 7.35938 5.41406 8.625 5.41406C8.76562 5.41406 8.87109 5.41406 9.01172 5.37891L10.3828 8.33203C9.32812 9.03516 8.625 10.2305 8.625 11.6016C8.625 13.7812 10.3828 15.5391 12.5625 15.5391C13.793 15.5391 14.8477 14.9766 15.5859 14.0977L18.8203 16.0312C18.7852 16.2422 18.75 16.4531 18.75 16.6641C18.75 17.9297 19.7344 18.9141 21 18.9141C22.4766 18.9141 23.25 17.6836 23.25 16.6641C23.25 15.7148 22.4766 14.4141 21 14.4141ZM8.625 4.28906C7.99219 4.28906 7.5 3.79688 7.5 3.16406C7.5 2.56641 7.99219 2.03906 8.625 2.03906C9.22266 2.03906 9.75 2.56641 9.75 3.16406C9.75 3.79688 9.22266 4.28906 8.625 4.28906ZM12.5625 14.4141C10.9805 14.4141 9.75 13.1836 9.75 11.6016C9.75 10.0547 10.9805 8.78906 12.5625 8.78906C14.1094 8.78906 15.375 10.0547 15.375 11.6016C15.375 13.1836 14.1094 14.4141 12.5625 14.4141ZM21 17.7891C20.3672 17.7891 19.875 17.2969 19.875 16.6641C19.875 16.0664 20.3672 15.5391 21 15.5391C21.5977 15.5391 22.125 16.0664 22.125 16.6641C22.125 17.2969 21.5977 17.7891 21 17.7891ZM17.5547 9L18.3281 8.40234C18.5742 8.22656 18.6445 7.875 18.4688 7.59375C18.2578 7.34766 17.9062 7.3125 17.6602 7.48828L16.8867 8.08594C16.6406 8.26172 16.5703 8.61328 16.7812 8.89453C16.957 9.14062 17.3086 9.17578 17.5547 9Z"
                                                            fill="#214DCE"
                                                        />
                                                    </svg>
                                                </div>
                                                <p className='frame25HomePage'>{i18n.t('Entreprises')}</p>
                                            </div>
                                            <h3 className='frame101HomePage'>{i18n.t('Nous vous connectons aux meilleurs freelances')}</h3>
                                            {device != 'desktop' &&
                                                <div className='frame31HomePage'>
                                                    <div className='frame33HomePage'>
                                                        <div className='frame34HomePage'>
                                                            <div className='frame35HomePage'>
                                                                <img src={profile1img} />
                                                            </div>
                                                            <div className='frame36HomePage'>
                                                                <h6 className='frame37HomePage'>A.C.</h6>
                                                                <p
                                                                    className='frame38HomePage'
                                                                >{i18n.t('Expert sécurité')}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            <h6 className='frame27HomePage frame27HomePageflex'>{i18n.t('Identifiez les experts les plus qualifiés pour mener à bien vos projets les plus critiques grâce à notre plateforme dédiée.')} </h6>
                                        </div>
                                        <div className='frame28HomePage'>
                                            <Button
                                                variant="contained"
                                                sx={{ height: 56 }}
                                                onClick={() => {
                                                    navigate('/homeClient');
                                                }}
                                                style={{
                                                    ...buttonStylesBlue(),
                                                    ...{
                                                        width: device == 'desktop' ? 'fit-content' : '100%'
                                                    }
                                                }}
                                            > {i18n.t('En savoir plus')}
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                sx={{ height: 56 }}
                                                onClick={() => {
                                                    navigate('/register');
                                                }}
                                                style={{
                                                    ...buttonStyles(),
                                                    ...{
                                                        width: device == 'desktop' ? 'fit-content' : '100%', borderColor: '#214DCE', color: '#214DCE'
                                                    }
                                                }}
                                            > {i18n.t('Nous Rejoindre')}</Button>
                                        </div>
                                    </div>
                                    {device == 'desktop' &&
                                        <div className='frame31HomePage'>
                                            <div className='frame33HomePage'>
                                                <div className='frame34HomePage'>
                                                    <div className='frame35HomePage'>
                                                        <img src={profile1img} />
                                                    </div>
                                                    <div className='frame36HomePage'>
                                                        <h6 className='frame37HomePage'>A.C.</h6>
                                                        <p
                                                            className='frame38HomePage'
                                                        >{i18n.t('Expert sécurité')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='frame32HomePage frame33HomePage'>
                                                <div className='frame34HomePage'>
                                                    <div className='frame35HomePage'>
                                                        <img src={profile2img} />
                                                    </div>
                                                    <div className='frame36HomePage'>
                                                        <h6
                                                            className='frame37HomePage'
                                                            style={{ color: '#272D3C' }}
                                                        >J.J.</h6>
                                                        <p
                                                            className='frame38HomePage'
                                                            style={{ color: '#214DCE' }}
                                                        >{i18n.t('Full Stack Dev')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='frame32HomePage frame33HomePage'>
                                                <div className='frame35HomePage'>
                                                    <img src={profile3img} />
                                                </div>
                                                <div className='frame36HomePage'>
                                                    <h6
                                                        className='frame37HomePage'
                                                        style={{ color: '#272D3C' }}
                                                    >M.M.</h6>
                                                    <p
                                                        className='frame38HomePage'
                                                        style={{ color: '#214DCE' }}
                                                    >{i18n.t('Consultant SAP SD/MM ')}</p>
                                                </div>
                                            </div>
                                            <div className='frame32HomePage frame33HomePage'>
                                                <div className='frame35HomePage'>
                                                    <img src={profile4img} />
                                                </div>
                                                <div className='frame36HomePage'>
                                                    <h6
                                                        className='frame37HomePage'
                                                        style={{ color: '#272D3C' }}
                                                    >J.W.</h6>
                                                    <p
                                                        className='frame38HomePage'
                                                        style={{ color: '#214DCE' }}
                                                    >{i18n.t('Data Analyst')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className='frame42HomePage'>
                                {device == 'desktop' &&
                                    <div className='frame43HomePage'>
                                        <DrawImgContainer5Home />
                                    </div>
                                }
                                <div className='frame44HomePage'>
                                    <div className='frame45HomePage'>
                                        <div className='frame24HomePage'>
                                            <svg
                                                width="24"
                                                height="19"
                                                viewBox="0 0 24 19"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M3 9.35156C1.98047 9.35156 0.75 10.125 0.75 11.6016C0.75 12.8672 1.73438 13.8516 3 13.8516C4.23047 13.8516 5.25 12.8672 5.25 11.6016C5.25 10.1602 3.98438 9.35156 3 9.35156ZM3 12.7266C2.36719 12.7266 1.875 12.2344 1.875 11.6016C1.875 11.0039 2.36719 10.4766 3 10.4766C3.59766 10.4766 4.125 11.0039 4.125 11.6016C4.125 12.2344 3.59766 12.7266 3 12.7266ZM7.21875 11.0391H6.62109C6.33984 11.0391 6.09375 11.3203 6.09375 11.6016C6.09375 11.8477 6.33984 12.1641 6.62109 12.1641H7.18359C7.5 12.1641 7.78125 11.918 7.78125 11.6016C7.78125 11.3203 7.5 11.0391 7.21875 11.0391ZM21 7.66406C21.9844 7.66406 23.25 6.92578 23.25 5.41406C23.25 3.9375 21.9844 3.16406 21 3.16406C19.9805 3.16406 18.75 3.9375 18.75 5.41406C18.75 6.67969 19.7344 7.66406 21 7.66406ZM21 4.28906C21.5977 4.28906 22.125 4.81641 22.125 5.41406C22.125 6.04688 21.5977 6.53906 21 6.53906C20.3672 6.53906 19.875 6.04688 19.875 5.41406C19.875 4.81641 20.3672 4.28906 21 4.28906ZM21 14.4141C20.5078 14.4141 20.0859 14.5547 19.7344 14.8008C19.5938 14.9062 19.4883 14.9766 19.418 15.082L16.1836 13.1484C16.3594 12.6562 16.5 12.1641 16.5 11.6016C16.5 9.45703 14.707 7.66406 12.5625 7.66406C12.1406 7.66406 11.7891 7.76953 11.4023 7.875L10.0312 4.92188C10.5234 4.5 10.875 3.86719 10.875 3.16406C10.875 1.72266 9.60938 0.914062 8.625 0.914062C7.14844 0.914062 6.375 2.17969 6.375 3.16406C6.375 4.42969 7.35938 5.41406 8.625 5.41406C8.76562 5.41406 8.87109 5.41406 9.01172 5.37891L10.3828 8.33203C9.32812 9.03516 8.625 10.2305 8.625 11.6016C8.625 13.7812 10.3828 15.5391 12.5625 15.5391C13.793 15.5391 14.8477 14.9766 15.5859 14.0977L18.8203 16.0312C18.7852 16.2422 18.75 16.4531 18.75 16.6641C18.75 17.9297 19.7344 18.9141 21 18.9141C22.4766 18.9141 23.25 17.6836 23.25 16.6641C23.25 15.7148 22.4766 14.4141 21 14.4141ZM8.625 4.28906C7.99219 4.28906 7.5 3.79688 7.5 3.16406C7.5 2.56641 7.99219 2.03906 8.625 2.03906C9.22266 2.03906 9.75 2.56641 9.75 3.16406C9.75 3.79688 9.22266 4.28906 8.625 4.28906ZM12.5625 14.4141C10.9805 14.4141 9.75 13.1836 9.75 11.6016C9.75 10.0547 10.9805 8.78906 12.5625 8.78906C14.1094 8.78906 15.375 10.0547 15.375 11.6016C15.375 13.1836 14.1094 14.4141 12.5625 14.4141ZM21 17.7891C20.3672 17.7891 19.875 17.2969 19.875 16.6641C19.875 16.0664 20.3672 15.5391 21 15.5391C21.5977 15.5391 22.125 16.0664 22.125 16.6641C22.125 17.2969 21.5977 17.7891 21 17.7891ZM17.5547 9L18.3281 8.40234C18.5742 8.22656 18.6445 7.875 18.4688 7.59375C18.2578 7.34766 17.9062 7.3125 17.6602 7.48828L16.8867 8.08594C16.6406 8.26172 16.5703 8.61328 16.7812 8.89453C16.957 9.14062 17.3086 9.17578 17.5547 9Z"
                                                    fill="#214DCE"
                                                />
                                            </svg>
                                        </div>
                                        <p className='frame25HomePage'>{i18n.t('Freelances')}</p>
                                    </div>
                                    <h3 className='frame101HomePage'>{i18n.t('Découvrez les meilleures opportunités et Boostez votre carrière')}</h3>
                                    {device != 'desktop' &&
                                        <div className='frame43HomePage'>
                                            <DrawImgContainer5Home />
                                        </div>
                                    }
                                    <h6 className='frame27HomePage frame27HomePageflex'>{i18n.t('Inscrivez-vous dès maintenant et explorez les demandes de nos clients pour découvrir de nouvelles opportunités.')} </h6>
                                    <div className='frame46HomePage'>
                                        <Button
                                            variant="contained"
                                            style={{ ...buttonStylesGreen(false), ...{ width: device == 'desktop' ? 'fit-content' : '100%' } }}
                                            //startIcon={<IconContainer1Home />}
                                            onClick={() => {
                                                navigate('/homeExpert');
                                            }}
                                        >
                                            {i18n.t('Solution Freelance')}
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            sx={{ height: 56 }}
                                            //startIcon={<Search />}
                                            onClick={() => {
                                                navigate('/register');
                                            }}
                                            style={{
                                                ...buttonStyles(),
                                                ...{
                                                    width: device == 'desktop' ? 'fit-content' : '100%', borderColor: '#214DCE', color: '#214DCE'
                                                }
                                            }}
                                        >
                                            {i18n.t('Nous Rejoindre')}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className='frame60HomePage'
                            style={{ marginTop: device == 'desktop' ? '70px' : '0px' }}
                        >
                            {device == 'desktop' &&
                                <div className='frame50HomePage'>
                                    <DrawImgProcess />
                                </div>
                            }
                            <div className='frame10023HomePage'>
                                <div className='frame61HomePage'>
                                    <h5 className='frame62HomePage'>{i18n.t('Pourquoi nous choisir')}</h5>
                                    <h1 className='frame63HomePage'>
                                        {i18n.t('Un processus')} <span className='frame64HomePage'>{i18n.t('facile')} </span> {i18n.t('et')} <span className='frame64HomePage'> {i18n.t('complet')} </span>{i18n.t('pour le sourcing.')}
                                    </h1>
                                </div>
                                <div className='frame65HomePage'>
                                    <div className='frame66HomePage'>
                                        <div className='frame67HomePage'>
                                            <DrawIconContainer6 />
                                        </div>
                                        <p className='frame68HomePage'> {i18n.t('Une CVthèqe intelligente et conviviale, avec un algorithme de matching intégré.')}</p>
                                    </div>
                                    <div className='frame66HomePage'>
                                        <div className='frame67HomePage'>
                                            <DrawIcon2Container6 />
                                        </div>
                                        <p className='frame68HomePage'>{i18n.t('Un processus de sourcing complet et intégré de bout en bout \'Source to Pay\'.')}</p>

                                    </div>
                                    <div className='frame66HomePage'>
                                        <div className='frame67HomePage'>
                                            <DrawIcon3Container6 />
                                        </div>
                                        <p className='frame68HomePage'> {i18n.t('Un système automatisé de gestion des comptes rendus d\'activité (CRA) et de facturation.')}</p>

                                    </div>
                                    <div className='frame66HomePage'>
                                        <div className='frame67HomePage'>
                                            <DrawIcon4Container6 />
                                        </div>
                                        <p className='frame68HomePage'> {i18n.t('Un outil de suivi intégré, regroupant toutes les fonctionnalités pour suivre vos projets.')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='frame51HomePage'>
                            <div className='frame52HomePage'>
                                <div className='frame53HomePage'>
                                    <DrawIcon1Grid2Container6 />
                                </div>
                                <p className='frame54HomePage'>
                                    {i18n.t('Simplicité et Efficacité')}
                                </p>
                            </div>
                            <div className='frame52HomePage'>
                                <div className='frame53HomePage'>
                                    <DrawIcon2Grid2Container6 />
                                </div>
                                <p className='frame54HomePage'>
                                    {i18n.t('Support')}
                                </p>
                            </div>
                            <div className='frame52HomePage'>
                                <div className='frame53HomePage'>
                                    <DrawIcon3Grid2Container6 />
                                </div>
                                <p className='frame54HomePage'>
                                    {i18n.t('Crédibilité')}
                                </p>
                            </div>
                            <div className='frame52HomePage'>
                                <div className='frame53HomePage'>
                                    <DrawIcon4Grid2Container6 />
                                </div>
                                <p className='frame54HomePage'>
                                    {i18n.t('Economic Value')}
                                </p>
                            </div>
                            <div className='frame52HomePage'>
                                <div className='frame53HomePage'>
                                    <DrawIcon5Grid2Container6 />
                                </div>
                                <p className='frame54HomePage'>
                                    {i18n.t('Solution compléte')}
                                </p>
                            </div>
                            <div className='frame52HomePage'>
                                <div className='frame53HomePage'>
                                    <DrawIcon6Grid2Container6 />
                                </div>
                                <p className='frame54HomePage'>
                                    {i18n.t('Matching')}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div
                        className='frame72HomePage'
                        style={{ paddingTop: device == 'desktop' ? '60px' : '0px' }}
                    >
                        <h3 className='frame101HomePage'> {i18n.t('Explorer Nos Blogs')}</h3>
                        <div className='frame75HomePage'>
                            <div
                                className='frame76HomePage'
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    navigate('/blog/1');
                                }}
                            >
                                <div className='frame77HomePage'>
                                    <LazyLoadImage
                                        src={blog1}
                                        width={device == 'desktop' ? '600px' : '100%'}
                                        height={'396px'}
                                        style={{ borderRadius: '20px' }}
                                    />
                                </div>
                                <div
                                    className='frame78HomePage'
                                >
                                    <div className='frame79HomePage'>
                                        <p className='frame80HomePage'>
                                            2024
                                        </p>
                                        <h4 className='titlesociete'>
                                            {i18n.t('Les Tendances de l\'IT qui Transforment notre Monde Numérique')}.
                                        </h4>
                                    </div>
                                    <p className='frame82HomePage'>
                                        {i18n.t('Par l\'équipe HTH')}
                                    </p>
                                </div>
                            </div>
                            <div className='frame83HomePage'>
                                <div className='frame84HomePage'>
                                    <h5 className='frame85HomePage'>
                                        {i18n.t('Articles en Vedette')}
                                    </h5>
                                    <div
                                        className='frame86HomePage'
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            navigate('/blogs');
                                        }}
                                    >
                                        <p
                                            className='frame87HomePage'
                                        >
                                            {i18n.t('Voir Plus')}
                                        </p>
                                        <div className='frame88HomePage'>
                                            <ChevronRightIcon />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className='frame89HomePage'
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        navigate('/blog/8');
                                    }}
                                >
                                    <div
                                        className='frame90HomePage'
                                        style={{ width: 'auto' }}
                                    >
                                        <LazyLoadImage
                                            src={blog8}
                                            width={'139px'}
                                            height={'139px'}
                                            style={{ borderRadius: '10px' }}
                                        />
                                    </div>
                                    <div
                                        className='frame91HomePage'

                                    >
                                        <div className='frame92HomePage'>
                                            <p
                                                className='frame93HomePage'
                                                style={{ margin: '0px' }}
                                            >
                                                2024
                                            </p>
                                            <div className='frame94HomePage'>
                                                <h6 className='blogTitles'>
                                                    {i18n.t('Attirer les Meilleurs Talents Freelances en IT: Stratégies Éprouvées pour le Succès')}
                                                </h6>
                                            </div>
                                            <p
                                                className='frame95HomePage'
                                                style={{ margin: '0px' }}
                                            >
                                                {i18n.t('Par l\'équipe HTH')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className='frame89HomePage'
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        navigate('/blog/5');
                                    }}
                                >
                                    <div
                                        className='frame90HomePage'
                                        style={{ width: 'auto' }}
                                    >
                                        <LazyLoadImage
                                            src={blog5}
                                            width={'139px'}
                                            height={'139px'}
                                            style={{ borderRadius: '10px' }}
                                        />
                                    </div>
                                    <div
                                        className='frame91HomePage'

                                    >
                                        <div className='frame92HomePage'>
                                            <p
                                                className='frame93HomePage'
                                                style={{ margin: '0px' }}
                                            >
                                                2024
                                            </p>
                                            <div className='frame94HomePage'>
                                                <h6 className='blogTitles'>
                                                    {i18n.t('Comment Démarrer en Tant que Freelance en IT : Guide Complet pour Réussir votre Aventure Indépendante')}

                                                </h6>
                                            </div>
                                            <p
                                                className='frame95HomePage'
                                                style={{ margin: '0px' }}
                                            >
                                                {i18n.t('Par l\'équipe HTH')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className='frame89HomePage'
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        navigate('/blog/4');
                                    }}
                                >
                                    <div
                                        className='frame90HomePage'
                                        style={{ width: 'auto' }}
                                    >
                                        <LazyLoadImage
                                            src={blog4}
                                            width={'139px'}
                                            height={'139px'}
                                            style={{ borderRadius: '10px' }}
                                        />
                                    </div>
                                    <div
                                        className='frame91HomePage'

                                    >
                                        <div className='frame92HomePage'>
                                            <p
                                                className='frame93HomePage'
                                                style={{ margin: '0px' }}
                                            >
                                                2024
                                            </p>
                                            <div
                                                className='frame94HomePage'

                                            >
                                                <h6 className='blogTitles'>
                                                    {i18n.t('Quel Langage Choisir pour Développer sa Plateforme : Guide Pratique')}
                                                </h6>
                                            </div>
                                            <p
                                                className='frame95HomePage'
                                                style={{ margin: '0px' }}
                                            >
                                                {i18n.t('Par l\'équipe HTH')}
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <Footer />
            </div>

            {/*<Footer
                styleProps={{
                    position: 'absolute',
                    left: '0px',
                    top: '5229.66px',
                    width: '100%'
                }} />*/}

        </React.Fragment>
    );
}

export default HomePage;